// dashboard-admin.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, combineLatest, map, switchMap } from 'rxjs';
import { PaymentService } from '../../services/payment.service';
import { LeaseService } from '../../services/lease.service';
import { RentalService } from '../../services/rental.service';
import { AuthService } from '../../services/auth.service';
import { TenantService } from '../../services/tenant.service';
import { LandlordService } from '../../services/landlord.service';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Rental } from 'src/app/models/rental.model';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { PaymentsChartComponent } from '../payment-charts/payment-charts.component';
import { Timestamp } from '@angular/fire/firestore';
@Component({
  selector: 'app-dashboard-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, PaymentsChartComponent],
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss']
})
export class DashboardAdminComponent implements OnInit {

  landlordIds$!: Observable<string[]>;
  subscriptions$!: Observable<{
  userName: string;
  email: string;
  status: string;
  amount: number;
  renewsOn: Date;
}[]>;
  paymentsChartData$!: Observable<{ label: string; total: number }[]>;
  paymentsThisMonth$!: Observable<number>;

  occupiedCount$!: Observable<number>;
  pendingCount$!: Observable<number>;
  availableCount$!: Observable<number>;
  payments$!: Observable<any>;
  rentalsWithLandlord$!: Observable<Rental[]>;
  tenantsWithRental$!: Observable<(User & { rentalAddress: string })[]>;

  leasesEndingSoon$!: Observable<any[]>;

  constructor(
    private auth: AuthService,
    private paymentService: PaymentService,
    private rentalService: RentalService,
    private leaseService: LeaseService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {

    this.landlordIds$ = this.auth.user$.pipe(
      map(user => {
        if (!user) return [];
        //if (user.role === 'manager') return user.landlordIds;
        return [user.landlordId];
      })
    );
    this.paymentsChartData$ =
      this.landlordIds$.pipe(
        switchMap(ids =>
          this.paymentService.getPaymentStatusBreakdownByLandlordIds(ids)
        )
      );
    this.subscriptions$  =
      this.landlordIds$.pipe(
        switchMap(ids =>
          this.userService.getUsersWithSubscriptions(ids)
        )
      );
      this.payments$  =
      this.landlordIds$.pipe(
        switchMap(ids =>
          this.paymentService.getPaymentsWithDetails(ids[0])
        )
      );
    this.paymentsThisMonth$ =
      this.landlordIds$.pipe(
        switchMap(ids =>
          this.paymentService.getPaymentsThisMonthForLandlords(ids)
        )
      );

    this.rentalsWithLandlord$ =
      this.rentalService.getRentalsWithLandlordName();

    this.tenantsWithRental$ =
      this.userService.getTenantsWithRental();

    this.leasesEndingSoon$ =
      this.leaseService.getLeasesEndingSoon();
  }

  goToTenants(){
    this.router.navigate(['/admin/tenants']);
  }
  goToLeases(){
this.router.navigate(['/admin/leases']);
  }
  goToRentals(){
this.router.navigate(['/admin/rentals']);
  }
  goToApplications(){
this.router.navigate(['/admin/applications']);
  }

}

